// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"UtaJU","bar-container":"_0FOub","bar":"nvC+Q","loading":"_5Uw-U"};